import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/css/Footer.css";
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Footer = () => {
  const numberRef = useRef(null);
  const navigate = useNavigate();
  const [visitors, setVisitors] = useState("0");

  // Fetch public analytics API
  useEffect(() => {
    const fetchVisitors = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/analytics/public`
        );
        setVisitors((res.data.totalVisits ?? 0).toString());
      } catch (error) {
        console.error("Visitor Fetch Error:", error);
        setVisitors("0");
      }
    };
    fetchVisitors();
  }, []);

  // Animate digits after render
  useEffect(() => {
    if (!numberRef.current) return;
    if (visitors === "0") return;

    // small delay to ensure <b> elements exist
    const timeout = setTimeout(() => {
      const digits = numberRef.current.querySelectorAll("b");
      digits.forEach((digit, index) => {
        digit.style.animationDelay = `${index * 0.15}s`;
        digit.classList.remove("digit-animate"); // reset
        void digit.offsetWidth; // force reflow
        digit.classList.add("digit-animate");
      });
    }, 50);

    return () => clearTimeout(timeout);
  }, [visitors]);

  return (
    <footer className="footer-section">
      <div className="footer-top">
        <Container>
          <h5 className="join-title">
            Site Visitors{" "}
            <span ref={numberRef}>
              {visitors.split("").map((digit, index) => (
                <b key={index}>{digit}</b>
              ))}
            </span>
          </h5>
        </Container>
      </div>

      <div className="footer-main">
        <Container>
          <Row>
            <Col md={3} sm={6} className="footer-brand">
              <img src={logo} alt="Biopharmacieaa Logo" className="footer-logo" />
              <h5 className="footer-company-name">Biopharmacieaa Pvt. Ltd</h5>
              <div className="footer-socials">
                <a href="https://www.facebook.com/GeoMediCs.Pharma/" target="_blank" rel="noreferrer">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="https://www.linkedin.com/company/80816437/admin/dashboard/" target="_blank" rel="noreferrer">
                  <i className="bi bi-linkedin"></i>
                </a>
                <a href="https://www.instagram.com/geobio_family/" target="_blank" rel="noreferrer">
                  <i className="bi bi-instagram"></i>
                </a>
              </div>
            </Col>

            <Col md={3} sm={6}>
              <h6>Product</h6>
              <ul>
                <li onClick={() => navigate("/Skin-Care-Products")}>Skin Care</li>
                <li onClick={() => navigate("/HairCareProducts")}>Hair care</li>
                <li onClick={() => navigate("/MedicalEnggProducts")}>Medical engineering</li>
              </ul>
            </Col>

            <Col md={3} sm={6}>
              <h6>Company</h6>
              <ul>
                <li onClick={() => navigate("/about")}>About</li>
                <li onClick={() => navigate("/contact")}>Contact us</li>
                {/* <li onClick={() => navigate("/jobs")}>Careers</li> */}
                <li onClick={() => navigate("/gallery")}>Gallery</li>
                <li onClick={() => navigate("/blogs")}>Blog</li>
              </ul>
            </Col>

            <Col md={3} sm={6}>
              <h6>Contact Us</h6>
              <p><a href="mailto:admin@biocieaa.com">admin@biocieaa.com</a></p>
              <p>(+91) 7776070000</p>
              <p>4th floor 401, Platina, above Crazy cheesy cafe, near HDFC Bank, Shri Krishna Nagar, Sagar Co-Operative Housing Society, Bavdhan, Pune, Maharashtra 411021</p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-bottom text-center">
        <Container>
          <p>All Rights Reserved | <a href="#">Terms and Conditions</a> | <a href="#">Privacy Policy</a></p>
          <p>Copyright © 2025</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
